var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 93,
    viewBox: "0 0 75 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_669",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46afeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e63c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344",
    transform: "translate(8.735 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.73, -6)",
    filter: "url(#Ellipse_669)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_669-2",
    "data-name": "Ellipse 669",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-connectivity-223831",
    transform: "translate(10.595 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M6.5,31.768a5.114,5.114,0,0,1,.975-3.008,16.189,16.189,0,0,1-.61-4.43,17.156,17.156,0,0,1,5.04-12.193A18.357,18.357,0,0,1,16.539,8.8a7.892,7.892,0,0,0-.081.975,7.7,7.7,0,0,0,1.422,4.471A11.852,11.852,0,0,0,12.312,24.33a11.707,11.707,0,0,0,.244,2.4A5.16,5.16,0,1,1,6.5,31.768Zm8.169,6.991a17.246,17.246,0,0,0,21.337-1.87,4.417,4.417,0,0,0,.732.041,5.162,5.162,0,1,0-5.162-5.162,4.913,4.913,0,0,0,.244,1.544,11.917,11.917,0,0,1-7.681,2.845,11.61,11.61,0,0,1-5.527-1.382A7.7,7.7,0,0,1,14.669,38.759Zm9.47-23.817a5.2,5.2,0,0,0,3.9-1.788,11.786,11.786,0,0,1,7.925,11.055,4.417,4.417,0,0,1,.732-.041,7.433,7.433,0,0,1,4.633,1.585c.041-.447.041-.935.041-1.382a17.156,17.156,0,0,0-5.04-12.193,16.92,16.92,0,0,0-7.478-4.389,5.143,5.143,0,1,0-4.715,7.153Z",
    transform: "translate(-6.5 -4.7)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.f6b4f0909949f2b39eec0f94038bfc54.svg";
export { ForwardRef as ReactComponent };